'use strict';

require('./cart.less');
let functions = require('../../modules/functions');

class Basket {
    /**
     * В конструктор передается изменямый элемент
     * @param element {HTMLElement}
     */
    constructor(element) {
        this.element = $(element);
        this.curItem = this.element.closest('.cart__item');
        this.alsoItems = this.curItem.find('.cart__also-items');
    }

    /**
     * Анимация показать сопуствующие товары
     */
    animateShowAlso() {
        let $alsoItems = this.alsoItems;
        this.alsoItems.css('max-height', 0).addClass('cart__also-items--visible');

        let trueHeight = functions.getTrueHeight(this.alsoItems);

        this.alsoItems.css('max-height', trueHeight);

        setTimeout(function() {
            $alsoItems.addClass('no-transition').css('max-height', 'none');
        }, 550);

        this.curItem.find('.js-cart-show-also-items').addClass('cart__also-link--hidden');
        this.curItem.find('.js-cart-hide-also-items').removeClass('cart__also-link--hidden');
    }

    /**
     * Анимация скрыть сопуствующие товары
     */
    animateHideAlso() {
        let $alsoItems = this.alsoItems;
        this.alsoItems.css('max-height', this.alsoItems.height() + 'px');

        setTimeout(function() {
            $alsoItems.removeClass('no-transition').css('max-height', 0);
        }, 25);

        setTimeout(function() {
            $alsoItems.removeClass('cart__also-items--visible');
        }, 550);

        this.curItem.find('.js-cart-show-also-items').removeClass('cart__also-link--hidden');
        this.curItem.find('.js-cart-hide-also-items').addClass('cart__also-link--hidden');
    }

    /**
     * Анимация удалить товар
     */
    animateDeleteProduct() {
        let $curItem = this.curItem;
        let $to = $('<div class="cart__item cart__item--empty" />').insertAfter(this.curItem);

        this.curItem.width(this.curItem.width());

        $to.height(this.curItem.height());
        this.curItem.css('top', this.curItem.position().top).addClass('cart__item--abs cart__item--deleting');
        $curItem.remove();
        $to.animate({ height: 0 }, 350, function() {
            $to.remove();
        });
    }

    /**
     * Ajax запрос на обновление количества товара в корзине
     * @param productId {number} - Ид товара
     * @param quantity {number} Количество
     * @param parentProductId {number} Ид товара родителя у связанных товаров
     */
    updateProductQuantity(productId, quantity, parentProductId) {
        if (parentProductId == undefined) {
            parentProductId = 0;
        }
        return $.ajax({
            url: '/ajax/action/basket_add_popup/add_to_basket_ajax/',
            data: 'PRODUCT_ID=' + productId + '&QUANTITY=' + quantity + '&PARENT_PRODUCT_ID=' + parentProductId
        }).then(function(result) {
            $('input[name="QUANTITY_' + productId + '"]').val(result.data['QUANTITY']);
            window.updateMiniBasket();
        });
    }
}
module.exports = Basket;

jQuery(function() {
    $(document).on('click', '.js-cart-show-also-items', function(e) {
        e.preventDefault();
        let basket = new Basket(this);
        basket.animateShowAlso();
    });

    $(document).on('click', '.js-cart-hide-also-items', function(e) {
        e.preventDefault();
        let basket = new Basket(this);
        basket.animateHideAlso();
    });

    $(document).on('click', '.js-delete-cart-item', function(e) {
        e.preventDefault();
        let basket = new Basket(this);
        basket.animateDeleteProduct();
    });
});



// WEBPACK FOOTER //
// ./blocks/cart/cart.js